<div class="page-container">
  <app-back-link link="/settings" label="Back to Settings"></app-back-link>
  <app-page-header title="Worker Jobs">
    <button mat-stroked-button (click)="load()" [disabled]="isLoading">
      <mat-icon>refresh</mat-icon> Refresh
    </button>
  </app-page-header>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  <div class="error-panel" *ngIf="errorMessage">{{ errorMessage }}</div>

  <ng-container *ngIf="!isLoading && !errorMessage">
    <p class="empty-state" *ngIf="dataSource.data.length === 0">
      No jobs in the last 24 hours.
    </p>

    <div class="table-scroll" *ngIf="dataSource.data.length > 0">
      <table mat-table [dataSource]="dataSource" class="jobs-table">

        <ng-container matColumnDef="job_type">
          <th mat-header-cell *matHeaderCellDef>Job Type</th>
          <td mat-cell *matCellDef="let job">
            <span class="job-type-badge">{{ job.job_type }}</span>
            <span class="llm-dot" *ngIf="job.has_llm_data" title="Has LLM prompt data">◆</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="entity">
          <th mat-header-cell *matHeaderCellDef>Entity</th>
          <td mat-cell *matCellDef="let job">
            <span *ngIf="job.entity_type" class="entity-cell">
              {{ job.entity_type }}<span *ngIf="job.entity_id" class="entity-id">#{{ job.entity_id }}</span>
            </span>
            <span *ngIf="!job.entity_type" class="dim">—</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let job">
            <span class="status-badge" [ngClass]="statusClass(job.status)">{{ job.status }}</span>
            <span *ngIf="job.attempt_count > 1" class="attempts-badge">×{{ job.attempt_count }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>Message</th>
          <td mat-cell *matCellDef="let job">
            <span class="message-cell">{{ job.message ?? '—' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let job">
            <span class="dim">{{ job.created_at ? (job.created_at | date:'M/d, h:mm a') : '—' }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [routerLink]="['/settings/jobs', row.id]"
            class="clickable-row"></tr>
      </table>
    </div>
  </ng-container>
</div>
